// import { ReceiptTwoTone } from '@material-ui/icons'
// import React from 'react'
// import socket from '../../../../api/socket'
// import EE from '../../../../api/eventemitter'
import Cursor from './cursor'
// import {getUserId} from '../../../../utility/function'

// class cursorMap extends React.Component {

//     constructor(props){
//         super(props)
//         this.state = {
//             playerCursorMap: new Map(),
//             initial: false,
//         }
//     }


//     componentDidMount(){

//         if(this.state.initial == false){
//             this.setState({
//                 playerCursorMap: this.props.initialCursorMap,
//                 initial: true
//             })
//         }

//         socket.on("Sync Player Cursor", (data) =>{
//             const {uID, playerCursor} = data
//             this.setState(state =>{
//                 const playerCursorMap = state.playerCursorMap

//                 playerCursorMap.set(uID, playerCursor)

//                 return{
//                     playerCursorMap
//                 }
//             })
//         })

//         EE.on("Cursor Move", data => {
//             const {event, uID} = data;
//             this.trackPlayerCursor(event,uID)
//         })
//     }

//     render(){
//         const playerCursorMap = this.state.playerCursorMap
//         const playerCursorArr = []
//         for(const [uID, cursorData] of playerCursorMap.entries()){
//             if(getUserId() !== uID){
//                 playerCursorArr.push(
//                     <Cursor
//                         key={uID}
//                         cursorData={cursorData}
//                     />
//                 )
//             }
//         }

//         return  playerCursorArr
//     }

//     trackPlayerCursor = (event, uID) =>{   
//         this.setState(state =>{
//             const playerCursorMap = state.playerCursorMap
//             const playerCursorData = playerCursorMap.get(uID)

//             playerCursorData.x = ((-this.props.canvasX + event.pageX) / this.props.scale)
//             playerCursorData.y = ((-this.props.canvasY + event.pageY - 112) / this.props.scale)

//             playerCursorMap.set(uID, playerCursorData)

//             return{
//                 playerCursorMap
//             }
//         }, () =>{
//             const playerCursorMap = this.state.playerCursorMap
            
//             socket.emit("Sync Player Cursor", {uID: uID, playerCursor: playerCursorMap.get(uID)})
//         })
//     }
// }


// export default cursorMap

import React from 'react'
import socket from '../../../../api/socket'
import EE from '../../../../api/eventemitter'
import { getUserId } from '../../../../utility/function'

class CursorMap extends React.Component {
    constructor(props) {
        super(props)
        // Store cursor data outside of state to avoid re-renders
        this.playerCursorMap = new Map()
        this.cursorRefs = new Map()      // DOM refs per player
        this.pendingEmit = null          // For throttling socket emits
        this.animFrameId = null          // For rAF batching
        this.dirtySet = new Set()        // Track which cursors need DOM update
        this.state = {
            playerIds: [],               // Only re-render when players join/leave
        }
    }

    componentDidMount() {
        // Initialize from props without triggering extra renders
        if (this.props.initialCursorMap) {
            this.playerCursorMap = new Map(this.props.initialCursorMap)
            this.setState({ playerIds: [...this.playerCursorMap.keys()] })
        }

        socket.on("Sync Player Cursor", this.handleSyncCursor)

        EE.on("Cursor Move", data => {
            const { event, uID } = data
            this.trackPlayerCursor(event, uID)
        })
    }

    componentWillUnmount() {
        socket.off("Sync Player Cursor", this.handleSyncCursor)
        // EE.off("Cursor Move")
        if (this.animFrameId) cancelAnimationFrame(this.animFrameId)
        if (this.pendingEmit) clearTimeout(this.pendingEmit)
    }

    handleSyncCursor = (data) => {
        const { uID, playerCursor } = data
        const isNewPlayer = !this.playerCursorMap.has(uID)

        this.playerCursorMap.set(uID, playerCursor)

        if (isNewPlayer) {
            // Only trigger React re-render when a new player joins
            this.setState({ playerIds: [...this.playerCursorMap.keys()] })
        } else {
            // Just move the DOM element directly — no React re-render
            this.dirtySet.add(uID)
            this.scheduleDOMUpdate()
        }
    }

    // Batch all DOM cursor updates into one rAF call
    scheduleDOMUpdate = () => {
        if (this.animFrameId) return  // Already scheduled, skip
        this.animFrameId = requestAnimationFrame(() => {
            this.animFrameId = null
            for (const uID of this.dirtySet) {
                const ref = this.cursorRefs.get(uID)
                const cursor = this.playerCursorMap.get(uID)
                if (ref && cursor) {
                    // Directly move the DOM node — zero React overhead
                    ref.style.transform = `translate(${cursor.x}px, ${cursor.y}px)`
                }
            }
            this.dirtySet.clear()
        })
    }

    trackPlayerCursor = (event, uID) => {
        const cursorData = this.playerCursorMap.get(uID) || { x: 0, y: 0 }

        cursorData.x = ((-this.props.canvasX + event.pageX) / this.props.scale)
        cursorData.y = ((-this.props.canvasY + event.pageY - 112) / this.props.scale)

        this.playerCursorMap.set(uID, cursorData)


        this.dirtySet.add(uID)
        this.scheduleDOMUpdate()

        if (!this.pendingEmit) {
            this.pendingEmit = setTimeout(() => {
                this.pendingEmit = null
                socket.emit("Sync Player Cursor", {
                    uID,
                    playerCursor: this.playerCursorMap.get(uID)
                })
            }, 33) // ~30fps
        }
    }

    render() {
        const myId = getUserId()
        return this.state.playerIds
            .filter(uID => uID !== myId)
            .map(uID => {
                const cursorData = this.playerCursorMap.get(uID) || { x: 0, y: 0 }
                return (
                    <div
                        key={uID}
                        ref={el => {
                            if (el) this.cursorRefs.set(uID, el)
                            else this.cursorRefs.delete(uID)
                        }}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            pointerEvents: 'none',
                            willChange: 'transform',  // GPU hint
                            transform: `translate(${cursorData.x}px, ${cursorData.y}px)`
                        }}
                    >
                        {/* Replace with your <Cursor> internals or pass ref down */}
                        <Cursor
                             key={uID}
                            cursorData={cursorData}
                        />
                    </div>
                )
            })
    }
}

export default CursorMap